import React from "react";
import { useProducts } from "@/hooks/useProducts";
import { ProductCard } from "@/components/ProductCard";
import { Loader2, Sparkles } from "lucide-react";

export default function PecansPage() {
  const { products, loading } = useProducts("pecans");
  const pecans = products[0];
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <p className="font-script text-gold text-3xl mb-1">More Than Popcorn…</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-black text-cream tracking-tight">Cinnamon Pecans</h1>
        <p className="text-cream/60 mt-4">Crispy, warm cinnamon pecans coated in a sweet, buttery glaze. Slow-roasted Southern pecans in small batches.</p>
      </div>
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="animate-spin text-gold" size={40} /></div>
      ) : pecans ? (
        <div className="grid lg:grid-cols-2 gap-8 items-start">
          <div className="relative">
            <img src={pecans.image} alt="Cinnamon Pecans" className="rounded-2xl border border-gold/30 shadow-2xl w-full aspect-square object-cover" />
            <span className="absolute -top-3 -left-3 btn-gold px-4 py-2 rounded-full font-bold text-sm flex items-center gap-1"><Sparkles size={14} /> Signature Roast</span>
          </div>
          <div className="max-w-md">
            <ProductCard product={pecans} />
          </div>
        </div>
      ) : (
        <p className="text-center text-cream/60">Cinnamon Pecans are currently unavailable. Please check back soon!</p>
      )}
    </div>
  );
}
